<template>
  <div class="public-content role-manage">
    <div class="breadcrumb">角色管理</div>
    <div class="add-category">
      <el-button round type="primary" ref="addRole" v-if="$hasPermission('crm:admin:role:save')" v-permission="'crm:admin:role:save'" @click="addRole">添加</el-button>
    </div>
    <div class="right-main">
      <div class="data-list">
        <el-table :data="roleList" border style="width: 100%">
          <el-table-column prop="name" label="角色名称" min-width="180"></el-table-column>
          <el-table-column prop="code" label="角色编号" min-width="180"></el-table-column>
          <el-table-column prop="remark" label="角色描述" min-width="180"></el-table-column>
          <el-table-column label="成员数量" min-width="180">
            <template v-slot:default="slotProps">
              <span class="color-blue" @click="$router.push({ path: './membermanage', query: { id: slotProps.row.id } })">{{ slotProps.row.userNumber }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="$hasPermission('crm:admin:role:updateStatus')" v-permission="'crm:admin:role:updateStatus'" label="是否启用" min-width="180">
            <template v-slot="scope">
              <el-switch :disabled='scope.row.editable === 0' :active-value="1" :inactive-value="0" v-model="scope.row.status" @change="changeStatus(scope.row)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column v-permission="['crm:admin:role:update', 'crm:admin:user:addAdmin']" label="操作" min-width="180">
            <template v-slot="scope">
              <span class="color-blue" @click="form = { fullName: '', phone: '', password: '', userName: '' }, title = '添加用户', hasUser = '', dialogVisible = true, roleMsg = scope.row.id"
                v-if="scope.row.status && $hasPermission('crm:admin:user:addAdmin') && scope.row.code !== 'ROLE_STOREADMIN' && scope.row.code !== 'ROLE_SUB_STOREADMIN' && scope.row.code !== 'ROLE_USER'">添加成员</span>
              <span class="color-blue" v-if="$hasPermission('crm:admin:role:update')" @click="changeRole(1, scope.row)">编辑</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--    分页-->
    <v-pagination class="v-pagination" :queryInfo="queryInfo" v-if="queryInfo.total !== ''" @changePage="changePage"></v-pagination>
    <CombinedDialog ref="dialogRef" @addMember="addMember"></CombinedDialog>
    <!-- 添加成员 -->
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="dialogVisible" @closed='$refs.form.resetFields()' width="30%">
      <p style="color:#666;font-weight: bold;padding-left:28px;margin-bottom:15px" v-show="hasUser === 200">添加成员成功，已将账号信息以短信形式发送</p>
      <p style="color:#666;font-weight: bold;padding-left:28px;margin-bottom:15px" v-show="hasUser === 201">添加成员成功</p>
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item v-show="hasUser === 200" label="手机号">
          <span>{{ form.userName }}</span>
        </el-form-item>
        <el-form-item v-show="hasUser === 200" label="密码">
          <span>{{ form.password }}</span>
        </el-form-item>
        <el-form-item v-show="hasUser !== 200 && hasUser !== 201" label="手机号" prop="phone">
          <el-input v-model="form.phone" style="width:250px" clearable></el-input>
          <el-button type="primary" @click="checkPhone" round>查询</el-button>
        </el-form-item>
        <el-form-item label="姓名" v-show="hasUser === 0">
          <el-input v-model="form.fullName" style="width:250px" clearable></el-input>
        </el-form-item>
      </el-form>
      <el-table v-show="hasUser === 1" :data="tableData" style="width: 95%">
        <el-table-column prop="phone" label="手机号"></el-table-column>
        <el-table-column prop="fullName" label="客户姓名"></el-table-column>
        <el-table-column prop="roleName" label="角色名称"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button v-show="hasUser !== 200" @click="dialogVisible = false">取 消</el-button>
        <el-button v-show="hasUser !== 200" type="primary" @click="addUser">确 定</el-button>
        <el-button v-show="hasUser === 200" @click="copy" round>复制信息</el-button>
      </span>
    </el-dialog>
    <input style="position: absolute;top: 0;left: 0;opacity: 0;z-index: -10;" type="text" id="copy" v-model="copyText">
  </div>
</template>
<script>
import CombinedDialog from '@/components/Dialog/CombinedDialog/index'
import VPagination from '@/components/Pagination/index'
import { roleGetRoleList, roleUpdateStatus, checkPhone, userAddAdmin, userDoAssign } from '@/api/crm'
export default {
  name: 'role-manage',
  components: {
    CombinedDialog,
    VPagination
  },
  data () {
    var checkUserName = (rule, value, callback) => {
      let reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
      if (reg.test(value)) {
        callback()
      } else {
        callback(new Error('请输入正确的手机号'))
      }
    }
    return {
      lock: true,
      title: '添加成员',
      roleMsg: '',
      hasUser: '',
      form: {
        fullName: '',
        phone: '',
        password: '',
        userName: ''
      },
      tableData: [],
      dialogVisible: false,
      roleList: [],
      queryInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      copyText: '',
      rules: {
        phone: [
          { validator: checkUserName, trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.getRoles(this.queryInfo)
  },
  methods: {
    copy () {
      var copyobject = document.getElementById('copy')
      copyobject.select()
      document.execCommand('Copy')
      this.$message.success('复制成功')
      this.dialogVisible = false
    },
    checkPhone () {
      this.$refs.form.validateField('phone', (val) => {
        if (val === '') {
          this.lock = false
          checkPhone(this.form.phone).then(res => {
            this.lock = true
            if (res.data.success) {
              if (res.data.data.exist) {
                this.tableData = [res.data.data]
                this.hasUser = 1
                this.getRoles(this.queryInfo)
              } else {
                this.hasUser = 0
              }
            }
          })
        }
      })
    },
    addUser () {
      if (!this.lock) { this.$message.warning('正在处理，请稍后'); return }
      if (this.hasUser === '') {
        this.$refs.form.validateField('phone', (val) => {
          if (val === '') {
            this.lock = false
            checkPhone(this.form.phone).then(res => {
              this.lock = true
              if (res.data.success) {
                this.tableData = [res.data.data]
                this.hasUser = 1
                this.getRoles(this.queryInfo)
              } else {
                this.hasUser = 0
              }
            })
          }
        })
      } else if (this.hasUser === 1) {
        this.lock = false
        userDoAssign({ roleId: this.roleMsg, ...this.tableData[0] }).then(res => {
          this.lock = true
          if (res.data.success) {
            this.getRoles(this.queryInfo)
            this.title = '确认提示'
            this.hasUser = 201
          }
        })
      } else if (this.hasUser === 0) {
        this.lock = false
        userAddAdmin({ roleId: this.roleMsg, ...this.form }).then(res => {
          this.lock = true
          if (res.data.success) {
            this.getRoles(this.queryInfo)
            this.title = '确认信息'
            this.hasUser = 200
            this.form = res.data.data
            this.form.phone = this.$msg.filterBridal(res.data.data.phone)
            this.form.userName = this.$msg.filterBridal(res.data.data.userName)
            this.copyText = '手机号：' + this.form.userName + ';密码：' + res.data.data.password
            this.$forceUpdate()
          }
        })
      } else if (this.hasUser === 201) {
        this.dialogVisible = false
      }
    },
    getRoles (val) {
      roleGetRoleList({
        pageNum: val.pageNum,
        pageSize: val.pageSize,
        roleVo: {
          name: '',
          status: '',
          attachType: 'HQ'
        }
      }).then((res) => {
        if (res.data.success) {
          this.queryInfo.total = res.data.data.total
          this.roleList = res.data.data.records.map(a => {
            if (a.userName) {
              a.userName = this.$msg.filterBridal(a.userName)
            }
            if (a.phone) {
              a.phone = this.$msg.filterBridal(a.phone)
            }
            return a
          })
        } else {
        }
      })
    },
    changePage (val) {
      this.queryInfo = val
      this.getRoles(this.queryInfo)
    },
    changeStatus (row) {
      roleUpdateStatus({ roleId: row.id, status: row.status }).then((res) => {
        if (res.data.success) {
          this.$message.success('更改成功')
        } else if (res.data.message === 'crm.special.role') {
          row.status = 1
        }
      })
    },
    changeRole (item, row) {
      if (item === 0) {
        this.$refs.dialogRef.show('addMember', '添加成员', '', '', row.id, '')
      }
      if (item === 1) {
        this.$router.push({
          path: '/editroles',
          query: {
            id: row.id,
            set: 'edit'
          }
        })
      }
    },
    addRole () {
      this.$router.push({
        path: '/editroles',
        query: {
          set: 'add'
        }
      })
    },
    addMember () {
      this.getRoles(this.queryInfo)
    }
  }
}
</script>
<style scoped lang="less">
@deep: ~">>>";

.role-manage {
  @{deep}.el-table {
    margin-top: 20px;

    span {
      padding: 0 5px;
    }

    tr {
      td {
        height: 50px !important;
        padding: 0;
      }
    }
  }
}
</style>
